module.exports = __webpack_public_path__ + "static/r-is-for-fe9709df1417ff49d98665b7c210f8ce.svg";